import { clsx } from "clsx";
import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";

interface LineItemRowProperties {
  readonly label: ReactNode;
  readonly value: string;
  readonly indent?: boolean;
  readonly className?: string;
  readonly labelClassName?: string;
  readonly valueClassName?: string;
}

/**
 * One row of a signed `$` line-item breakdown (label left, value right) —
 * shared by any section that renders a list of financial line items rolling
 * up into subtotal/grand-total rows (e.g. Deal Status's Advance breakdown).
 * `indent` marks a sub-item nested under its parent line (e.g. "VSC Net
 * Dealer Cost" under "Vehicle Service Contract"); `className` lets a caller
 * mark a row as a bold subtotal with a divider above it.
 */
function LineItemRow({
  label,
  value,
  indent = false,
  className = "",
  labelClassName = "",
  valueClassName = "",
}: LineItemRowProperties) {
  return (
    <div
      className={clsx(
        "text-(length:--typography-base-sizes-extra-small-font-size)/(--typography-base-sizes-extra-small-line-height) gap-(--spacing-2) flex items-baseline justify-between",
        indent && "pl-(--spacing-2)",
        className
      )}
    >
      <span className={cn(!indent && "text-primary", labelClassName)}>{label}</span>
      <span className={valueClassName}>{value}</span>
    </div>
  );
}

export default LineItemRow;
